<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="orderId">
      <b>订单种类：</b>
      <el-select v-model="queryParams.status" placeholder="请选择" @change="getList"
                 style="width: 110px;">
        <el-option
            label="入库订单"
            :value="1"
        ></el-option>
        <el-option
            label="出库订单"
            :value="2"
        ></el-option>
      </el-select>

      <b>订单编号：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.code"
                placeholder="订单编号"/>
      <b>订单名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.name"
                placeholder="订单名称"/>
      <b>备注：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.remake"
                placeholder="请输入订单备注"/>
      <b>订单时间：</b>
      <el-date-picker
          style="width: 120px;"
          v-model="queryParams.stime"
          type="date"
          placeholder="起始日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
      </el-date-picker>
      <b>-</b>
      <el-date-picker
          style="width: 120px;"
          v-model="queryParams.etime"
          type="date"
          placeholder="截至日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>

      <el-upload style="    width: 83px;
    float: right;   margin-left: 4px" class="is-round"
                 v-if="checkPrower('cprk')"
                 v-show="queryParams.status===1"
                 ref="upfile"
                 :show-file-list="false"
                 action="#"
                 :auto-upload="false"
                 :on-change="pwhandleChange"
                 :file-list="pwfileList">
        <el-button size="small" type="primary" style=" border-radius: 20px;    height: 38.333334px;font-size: 14px">
          新建入库单
        </el-button>

        <!--        <div slot="tip" v-if="form.state==null||form.state==1" style="float: right;margin-top: 0px"
                     class="el-upload__tip">



                </div>-->
      </el-upload>
      <el-button type="primary" v-show="queryParams.status===2" style="margin-left: 7px;" @click="createckorder()"
                 size="medium" round><i
          class="el-icon-circle-plus"></i>新建出库单
      </el-button>
      <el-button type="primary" v-show="queryParams.status===1" @click="downloadTemplate" style="float: right"
                 size="medium" round><i class="el-icon-download"></i>模板
      </el-button>
      <el-button type="warning" @click="cleardata" style="float: right" size="medium" round><i
          class="el-icon-refresh"></i>重置
      </el-button>
    </div>
    <el-table id="orderTa" v-loading="loading"
              :data="tableData"
              :row-class-name="getRowClass"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column label="订单名称" prop="name" align="center">
        <template slot-scope="scope">
          <a style="color: #409EFF" @click="showOrder(scope.row.id)">{{ scope.row.name }}</a>
        </template>
      </el-table-column>
      <el-table-column label="订单编号" prop="code" align="center"></el-table-column>
      <el-table-column label="订单类型" prop="sstype" align="center">
        <template slot-scope="scope">
          {{ formatestate(scope.row.sstype) }}
        </template>
      </el-table-column>
      <el-table-column label="订单时间" prop="rktime" align="center" :formatter="formatDate">
      </el-table-column>
      <el-table-column label="备注" prop="remake" align="center" width="150"/>
      <el-table-column
          align="center" label="操作" width="300">

        <template slot-scope="scope">
          <el-button v-if="(scope.row.type=='2' && checkPrower('delOrder')) && scope.row.ckwcstate=='0'"
                     type="danger"
                     size="mini"
                     @click="delOrder(scope.row)">
            <i class="el-icon-delete"></i>
            删除订单
          </el-button>
          <el-button v-if="scope.row.type=='1' && checkPrower('dybd')"
                     size="mini"
                     @click="getproctrkd(scope.row)">
            <i class="el-icon-setting"></i>
            打印入库单
          </el-button>
          <el-button v-if="scope.row.type=='2' && checkPrower('dybd')"
                     size="mini"
                     @click="getproctckd(scope.row)">
            <i class="el-icon-video-play"></i>
            打印出库单
          </el-button>
          <el-button v-if="(scope.row.type=='2' && checkPrower('dybd')) && scope.row.ckwcstate=='1'"
                     size="mini"
                     @click="getExport(scope.row)">
            <i class="el-icon-download"></i>
            导出订单
          </el-button>
          <el-button
              size="mini"
              @click="getproctList(scope.row)">
            <i class="el-icon-video-pause"></i>
            订单设备
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <template>
      <div>
        <pagination
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>
    <el-dialog :title="rkdtitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" id="rkd">
      <el-form ref="formrk" :model="form" id="scfrom">

        <el-form-item label="订单名称:" label-width="105px">
          <el-input v-model="selectTable.name" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="订单编号:" label-width="105px">
          <el-input v-model="selectTable.code" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="入库时间:" label-width="105px">
          <el-date-picker :disabled="!isupdate"
                          v-model="selectTable.rktime"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :clearable="true"
                          auto-complete="off"
          />
        </el-form-item>
        <el-form-item label="入库类型:" label-width="105px">
          <el-select v-model="selectTable.sstype" :disabled="!isupdate" placeholder="请选择" style="    width: 100%;">
            <el-option
                v-for="item in rksstype"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="仓库:" label-width="105px">
          <el-select v-model="selectTable.ssware" :disabled="!isupdate" placeholder="请选择" style="    width: 100%;">
            <el-option
                v-for="item in ckList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商:" label-width="105px">
          {{ supplierName }}
        </el-form-item>
        <el-form-item label="备注:" label-width="105px">
          <el-input v-model="selectTable.remake" auto-complete="off" type="text" rows="2"
                    :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item>
          <el-table v-loading="loading"
                    :data="selectTable.spxx"
                    style="width: 100%">
            <el-table-column
                type="index"
                align="center"
                width="70" label="序号">
              <template slot-scope="scope">
                <div v-text="scope.$index+1"></div>
              </template>
            </el-table-column>
            <el-table-column label="物料名字" prop="pname" align="center"></el-table-column>
            <el-table-column label="数量" prop="num" align="center"></el-table-column>
          </el-table>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button @click="Submitdc" v-if="isupdate">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="ckdtitle" :visible.sync="dialogFormVisibleck" :close-on-click-modal="false" id="rkd">
      <el-form ref="formck" :model="form" id="scfrom">

        <el-form-item label="订单名称:" label-width="105px">
          <el-input v-model="selectTable.name" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="订单编号:" label-width="105px">
          <el-input v-model="selectTable.code" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="装配订单:" label-width="105px">
          <el-select v-model="selectTable.mid" :disabled="true" v-if="!isupdate"
                     @change="handlebyMatch(selectTable.mid)" placeholder="请选择" style="    width: 100%;">
            <el-option
                v-for="item in MatchListAll"
                :key="item.id"
                :label="item.oname"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="selectTable.mid" v-else @change="handlebyMatch(selectTable.mid)" placeholder="请选择"
                     style="    width: 100%;">
            <el-option
                v-for="item in MatchList"
                :key="item.id"
                :label="item.oname"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库时间:" label-width="105px">
          <el-date-picker :disabled="!isupdate"
                          v-model="selectTable.rktime"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :clearable="true"
                          auto-complete="off"
          />
        </el-form-item>
        <el-form-item label="出库类型:" label-width="105px">
          <el-select v-model="selectTable.sstype" :disabled="!isupdate" placeholder="请选择" style="    width: 100%;">
            <el-option
                v-for="item in cksstype"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库:" label-width="105px">
          <el-select v-model="selectTable.ssware" :disabled="!isupdate" placeholder="请选择" style="    width: 100%;">
            <el-option
                v-for="item in ckList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户商:" label-width="105px">
          <el-select v-model="selectTable.cid" :disabled="!isupdate" placeholder="请选择" style="    width: 100%;">
            <el-option
                v-for="item in khlist"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" label-width="105px">
          <el-input v-model="selectTable.remake" auto-complete="off" type="text" rows="2"
                    :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item>
          <el-table
              :key="componentKey"
              ref="plxTable"
              :data="selectTable.spxx"
              :max-height="460"
              border
              highlight-current-row
              style="float: left; width: 100%;"
          >
            <!-- 物料 -->
            <el-table-column label="物料" prop="pid">
              <template #default="{ row}">
                <span>{{ formatproduct(row.pid) }}</span>
              </template>
            </el-table-column>

            <!-- 数量 -->
            <el-table-column label="数量" prop="num" width="120">
              <template #default="{ row }">
                <span>{{ row.num }}</span>
              </template>
            </el-table-column>

            <!-- 参数 -->

          </el-table>

        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleck = false">取 消</el-button>
        <el-button @click="Submitck" v-if="isupdate">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="订单设备列表" :visible.sync="dialogFormVisiblesb" :close-on-click-modal="false">
      <el-collapse accordion>
        <el-collapse-item
            v-for="(item, index) in sblbList"
            :key="index"
            :title="`原料 ${index + 1} - ${item.pname + '------- ' + item.comname +'-------'+item.serial.length+'台'|| '未命名'}`"
            :name="index"
        >

          <!-- 其他字段可以放在这里 -->

          <!-- 编码列表 - 用 el-tag 展示（美观、支持换行） -->

          <div v-if="item.serial && item.serial.length > 0">
            <el-tag
                v-for="(code, i) in item.serial"
                :key="i"
                type="info"
                effect="plain"
                style="margin: 0 8px 8px 0;"
            >
              {{ code }}
            </el-tag>
          </div>
          <div v-else style="color: #999;">
            无编码
          </div>


        </el-collapse-item>
      </el-collapse>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisiblesb = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="订单打印" :visible.sync="dialogFormVisibledy" :close-on-click-modal="false">
      <el-tabs v-model="activeName" type="border-card" style="height: 65vh;">
        <el-tab-pane
            v-for="(url, index) in imageUrls"
            :key="index"
            :label="getTabLabel(url)"
            :name="index.toString()"
        >
          <div class="image-wrapper">
            <el-image
                :src="url"
                fit="contain"
                :preview-src-list="[url]"
                style="max-height: 60vh; max-width: 100%; display: block; margin: 0 auto;"
                :lazy="false"
            >
              <div slot="error" class="image-error">
                加载失败
              </div>
              <div slot="placeholder" class="image-loading">
                加载中<span class="dotting"></span>
              </div>
            </el-image>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibledy = false">关 闭</el-button>
        <el-button v-if="dialogDc" @click="printOrder" type="primary">导出为表格</el-button>
        <el-button v-else @click="printOrderCk" type="primary">导出为表格</el-button>
      </div>
    </el-dialog>
    <el-dialog title="消息提醒" :visible.sync="dialogMessage" :close-on-click-modal="false">
      <span>{{ dialogMessage }}</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogMessage = undefined">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    return {
      formRules: {
        name: [
          { required: true, message: '订单名称不能为空', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '订单编号不能为空', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '只能包含字母、数字、下划线和中划线', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        mid: [
          { required: true, message: '请选择装配订单', trigger: 'change' }
        ],
        rktime: [
          { required: true, message: '请选择出库时间', trigger: 'change' }
        ],
        sstype: [
          { required: true, message: '请选择出库类型', trigger: 'change' }
        ],
        ssware: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        cid: [
          { required: true, message: '请选择客户商', trigger: 'change' }
        ],
        remake: [
          { max: 500, message: '备注不能超过500个字符', trigger: 'blur' }
        ],
        spxx: [
          {
            required: true,
            message: '请至少添加一条订单明细',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请至少添加一条订单明细'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      MatchListAll: [],
      MatchList: [],
      dialogMessage: undefined,
      imageUrls: [],
      activeName: '0',
      test: [],
      spList: [],
      khlist: [],
      ckdtitle: '',
      dialogDc:false,
      dialogFormVisibledy: false,
      dialogFormVisibleck: false,
      sblbList: [],
      dialogFormVisiblesb: false,
      ckList: [],
      rkdtitle: '',
      rktypeList: [],
      rksstype: [],
      rksstypeshow: [],
      cksstype: [],
      selectTable: {
        spxx: [],
      },
      comList: [],
      file1src: '',
      total: 0,
      pid: '',
      scinfo: {
        id: '',
        scstate: '',
        opinion: ''
      },
      projecttypes: [],
      pwfileList: [],
      form: {
        dictValue: '',
        dictType: '',
        level: ''
      },
      dialogpdfVisibledel: false,
      isupdate: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sstype: undefined,
        name: undefined,
        code: undefined,
        stime: undefined,
        etime: undefined,
        status: 0
      },
      componentKey: 0,
      // 菜单列表
      menuOptions: [],
      dialogFormVisible: false,
      dialogFormVisiblec: false,
      dialogFormData: [],
      tableData: [],
      loading: false,
      fileById:undefined,
    }
  },
  computed: {

    supplierName() {
      if (!this.selectTable.cid) return '—';  // 没选时显示占位

      const supplier = this.comList.find(item => item.id === this.selectTable.cid);
      return supplier ? supplier.name : '未知供应商';
    }
  },

  mounted() {
    this.getList();
    this.getDic('rklx')
    this.getcom();
    this.getck();
    this.getproct();
    this.getMatchingAll();

  },
  methods: {
    printOrder(){
      this.$request.getHttp({
        url: "/basic/oderRkExport",
        params: {id: this.fileById,type:'1'},
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('导出成功正在下载！')
            const link = document.createElement('a');
            link.href = data.msg;
            link.download = '入库单'; // 设置下载文件名
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


          } else {
            this.$message.warning(data.msg)
          }


        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })

    },
    printOrderCk(){
      this.$request.getHttp({
        url: "/basic/oderRkExport",
        params: {id: this.fileById,type:'2'},
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('导出成功正在下载！')
            const link = document.createElement('a');
            link.href = data.msg;
            link.download = '出库单'; // 设置下载文件名
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


          } else {
            this.$message.warning(data.msg)
          }


        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })

    },

    handlebyMatch(mid) {
      this.$request.getHttp({
        url: "/basic/getOrderMatch",
        params: {id: mid},
        success: (data) => {
          if (data.data == null) {
            this.selectTable.spxx = []
          } else {
            this.selectTable.spxx = data.data
          }
          this.componentKey += 1;
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },
    getRowClass({row}) {
      console.log(row)
      if (row.type == '2' && row.ckwcstate == '1') {
        return 'row-green';
      } else if (row.type == '2' && row.ckwcstate == '0') {
        return 'row-yellow';
      }
    },
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },
    handlePrnedd(row) {
      this.selectTable.spxx.forEach(item => {
        const match = this.spList.find(sp => sp.id === item.pid);
        if (match) {
          item.yz = match.yz;
        }
      });
    },
    getTabLabel(url) {
      const filename = url.split('/').pop(); // 取最后一部分
      let name = filename.replace('.png', ''); // 去掉扩展名
      return name; // 默认用文件名
    },
    formatproduct(str) {
      const found = this.spList.find(item => item.id == str)
      return found ? found.name : ''   // 没找到就返回空字符串或 '--'
    },
    getproct() {
      this.$request.postHttp({
        url: "/basic/getspAndSy",
        success: (data) => {
          this.spList = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    insertEvent() {
      let record = {
        pid: undefined,
        num: undefined,
        yz: undefined,
      }
      // 同时 push 到 test（保持同步）
      this.selectTable.spxx.push(record)
      // 加入行, 表示加入行的row对象，row为空则插入第一行，为-1插入最后一行
      let {row: newRow} = this.$refs.plxTable.insertRow(record, -1)
      // 激活单元格编辑
    },
    delEvent(row) {
      console.log(row)
      // 删除前可以进行一些操作，比如提示确认
      this.$confirm('此操作将删除该行设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row)
        // 确认删除时，splice方法会直接修改原数组
        this.selectTable.spxx.splice(row, 1);
        this.$message({
          type: 'success',
          message: '删除成功!提交后上传至服务器'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });


    },
    createckorder() {
      this.ckdtitle = '新建出库单'
      this.selectTable = this.$options.data().selectTable
      this.isupdate = true
      this.dialogFormVisibleck = true
      this.getMatching();
    },
    getMatchingAll() {
      this.$request.postHttp({
        url: "/basic/MatchListAll",
        success: (data) => {
          this.MatchListAll = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    getMatching() {
      this.$request.postHttp({
        url: "/basic/MatchListByOrder",
        success: (data) => {
          this.MatchList = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })

    },
    getproctrkd(row) {
      this.$request.getHttp({
        url: "/basic/getproctrkd",
        params: {id: row.id},
        success: (data) => {
          this.imageUrls = data.data
          this.dialogFormVisibledy = true;
          this.fileById=row.id
          this.dialogDc=true
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getproctckd(row) {
      this.$request.getHttp({
        url: "/basic/getproctckd",
        params: {id: row.id},
        success: (data) => {
          this.imageUrls = data.data
          this.dialogFormVisibledy = true;
          this.fileById=row.id
          this.dialogDc=false
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getExport(row) {

      this.$request.getHttp({
        url: "/basic/getExport",
        params: {id: row.id},
        success: (data) => {
          const urls = data.data
          // 情况A：单个URL
          if (typeof urls === 'string') {
            this.downloadFile(urls, '订单详情导出.xlsx');  // 第二个参数是建议的文件名
          }
          // 情况B：多个URL
          else if (Array.isArray(urls)) {
            urls.forEach((url, index) => {
              this.downloadFile(url, `订单详情导出_${index + 1}.xlsx`);
            });
          }
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    downloadFile(url, fileName = 'download.xlsx') {
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;          // 可选：指定下载文件名
      // link.target = '_blank';         // 如果想新窗口打开预览而不是下载，可打开这行
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);   // 清理
    },
    delOrder(row) {

      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/basic/delOrder",
          params: {id: row.id},
          success: (data) => {
            if (data.code == 200) {
              this.$message.success('删除成功！')
            } else {
              this.$message.warning(data.msg)
            }


            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    getproctList(row) {
      this.$request.postHttp({
        url: "/basic/getproctList",
        params: {id: row.id, type: row.type},
        success: (data) => {
          this.sblbList = data.data
          this.dialogFormVisiblesb = true;
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    formatDate(row) {
      const timestamp = row.rktime;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
      return formattedDate;
    },
    //项目文档
    pwhandleChange(file, fileList) {
      this.pwfileList = fileList.slice(-3);
      this.upload()
    },
    upload() {
      let fd = new FormData();

      //文件信息中raw才是真的文件
      fd.append("file", this.pwfileList[0].raw);
      //console.log(item.raw)
      this.$request.postHttp(
          {
            url: "/basic/upOrder",
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: fd,
            success: (data) => {
              if (data.code == '500') {
                this.dialogMessage = data.msg
              } else {
                this.isupdate = true
                this.rkdtitle = '新增入库单'
                this.dialogFormVisible = true;
                this.selectTable = data.data
              }
              this.pwfileList = this.$options.data().pwfileList
            },
            error: (error) => {
              console.error("Error:", error);

              // 执行失败时的操作
            },
          })
    },
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.rktypeList = data.data
          const list = data.data ? data.data : []   // 防止 undefined

          list.forEach(item => {
            const value = item.dictValue || ''
            if (value.length < 2) return

            const lastTwo = value.slice(-2)   // 后两位

            if (lastTwo === '入库') {
              this.rksstype.push(item)        // 保留完整对象，方便后续使用 id/code 等
              if (value !== '退货入库') {
                this.rksstypeshow.push(item)
              }

            } else if (lastTwo === '出库') {
              this.cksstype.push(item)
            }
          })
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getcom() {
      this.$request.postHttp({
        url: "/basic/getcom",
        success: (data) => {
          this.comList = data.data
          this.comList.forEach(item => {
            const value = item.companyType || ''
            if (value == 2) return
            this.khlist.push(item)
          })
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    getck() {
      this.$request.postHttp({
        url: "/basic/getck",
        success: (data) => {
          this.ckList = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    downloadTemplate() {
      // 模板放在 public/templates/入库模板.xlsx
      const link = document.createElement('a');
      link.href = '/入库单导入模板.xlsx';  // 相对于public目录的路径
      link.download = '入库单模板.xlsx';        // 下载时的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    ,
    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      console.log(this.checkPrower('cprk'))
      if (this.queryParams.status === 0 && this.checkPrower('cprk')) {
        this.queryParams.status = 1
      } else if (this.queryParams.status === 0 && this.checkPrower('cpck')) {
        this.queryParams.status = 2
      }
      this.$request.postHttp({
        url: "/basic/OrderList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    Submitdc() {

      // ============ 1. 基础字段校验 ============
      if (!this.selectTable.name?.trim()) {
        this.$message.warning('请输入订单名称');
        return;
      }

      if (!this.selectTable.sstype) {
        this.$message.warning('请选择出库  类型');
        return;
      }

      if (!this.selectTable.ssware) {
        this.$message.warning('请选择仓库');
        return;
      }

      if (!this.selectTable.cid) {
        this.$message.warning('请选择客户');
        return;
      }

      this.$request.postHttp({
        url: "/basic/saveOrderInfo",
        data: JSON.stringify(this.selectTable),
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('创建入库单成功')
          }

          this.dialogFormVisible = false
          this.getList();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    Submitck() {
      // ============ 1. 基础字段校验 ============
      if (!this.selectTable.name?.trim()) {
        this.$message.warning('请输入订单名称');
        return;
      }

      if (!this.selectTable.sstype) {
        this.$message.warning('请选择出库类型');
        return;
      }

      if (!this.selectTable.ssware) {
        this.$message.warning('请选择仓库');
        return;
      }

      if (!this.selectTable.cid) {
        this.$message.warning('请选择客户');
        return;
      }
// ============ 2. 物料明细校验 ============
      if (!this.selectTable.spxx || this.selectTable.spxx.length === 0) {
        this.$message.warning('物料有问题，至少要一条物料信息才可出库');
        return;
      }

// 1. 先匹配库存（Map 优化）
      /*      const spMap = new Map(this.spList.map(sp => [sp.id, sp.dy]));
            this.selectTable.spxx.forEach(item => {
              console.log( this.selectTable.spxx)
              const dy = spMap.get(item.pid);
              if (dy !== undefined) {
                item.yz = dy;
              }
            });*/
// 2. 验证：pid 是否重复（记录索引）
      const pidMap = new Map();  // pid -> 第一次出现的索引
      const duplicateIndexes = [];
      this.selectTable.spxx.forEach((item, index) => {
        const rowNum = index + 1;  // 第几条物料（从1开始）

        if (pidMap.has(item.pid)) {
          duplicateIndexes.push({
            pid: item.pid,
            index1: pidMap.get(item.pid) + 1,  // 第一次出现的条数
            index2: rowNum                     // 重复出现的条数
          });
        } else {
          pidMap.set(item.pid, index);
        }
      });
// 3. 验证：库存是否超限（记录索引）
      const overstockItems = this.selectTable.spxx
          .map((item, index) => ({
            ...item,
            rowNum: index + 1
          }))
          .filter(item => item.num > item.yz);
      // pid 存在且 num 为 0 或为空
      const zeroNumItems = this.selectTable.spxx
          .map((item, index) => ({...item, rowNum: index + 1}))
          .filter(item => item.pid && (item.num === 0 || item.num === null || item.num === undefined || item.num === ''));
      if (zeroNumItems.length > 0) {
        const msg = zeroNumItems.map(item =>
            `第${item.rowNum}条物料 ${item.name || item.pid} 数量不能为0`
        ).join('；');

        this.$message.warning(msg)
        return;
      }
// 4. 组合提示（优先提示重复，再提示库存）
      if (duplicateIndexes.length > 0) {
        const msg = duplicateIndexes.map(item =>
            `第${item.index1}条和第${item.index2}条物料重复`
        ).join('；');

        this.$message.warning(msg)
        return;
      }
      if (overstockItems.length > 0) {
        const msg = overstockItems.map(item =>
            `第${item.rowNum}条物料填报已超出库存数量`
        ).join('；');

        this.$message.warning(msg)
        return;
      }
      this.selectTable.type = '2'
      this.$request.postHttp({
        url: "/basic/saveOrderInfo",
        data: JSON.stringify(this.selectTable),
        success: (data) => {
          if (data.code == '200') {
            this.$message.success("创建出库单成功！")
          }

          this.dialogFormVisibleck = false
          this.getList();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    createdata() {
      this.form = this.$options.data().form
      this.dialogFormVisiblec = true;
    },

    formatestate(str) {
      const found = this.rktypeList.find(item => item.dictCode == str)
      return found ? found.dictValue : ''   // 没找到就返回空字符串或 '--'
    },
    showOrder(oid) {
      this.$request.getHttp({
        url: "/basic/getOrderInfo",
        params: {id: oid},
        success: (data) => {
          this.selectTable = data.data

          this.isupdate = false
          if (this.selectTable.type == '2') {
            this.rkdtitle = '浏览出库单'
            this.dialogFormVisibleck = true;
          } else {
            this.rkdtitle = '浏览入库单'
            this.dialogFormVisible = true;
          }

        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })

    }

  }
  ,
}
</script>
<style>

#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
.el-table .row-green {
  background-color: #f0f9eb !important; /* 浅绿色 */
}

.el-table .row-green:hover > td {
  background-color: #e1f3d8 !important; /* 悬停加深 */
}

.el-table .row-yellow {
  background-color: #ffebc1 !important; /* 浅绿色 */
}

.el-table .row-yellow:hover > td {
  background-color: #ffde8e !important; /* 浅绿色 */
}

#pdfdialog .el-dialog--small {
  top: 3% !important;
  width: 86% !important;
  height: 93% !important;
}

#scfrom .el-input.is-disabled .el-input__inner {
  background-color: white;
  border-color: white;
  color: #4e4e59;
  padding-bottom: 4px;
}

#scfrom .el-textarea.is-disabled .el-textarea__inner {
  background-color: white;
  border-color: #C0C4CC;
  color: #4e4e59;
  padding-bottom: 4px;
}

#rkd .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

#orderId .el-button.is-round {
  border-radius: 20px;
  padding: 12px 3px !important;
}

#orderTa .el-button--mini, .el-button--mini.is-round {
  padding: 7px 5px;
}
</style>